import { render, staticRenderFns } from "./Update-Lead.vue?vue&type=template&id=50b55f39"
import script from "./Update-Lead.vue?vue&type=script&lang=js"
export * from "./Update-Lead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports